import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import { firebaseLogin, firebaseSignup } from '../services';
import { AcceptInviteProvider } from '../providers';

const styles: StyleRulesCallback = t => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    height: '100vh'
  },
  title: {
    marginTop: 48,
    marginBottom: 24
  },
  input: {
    marginBottom: 18
  },
  error: {
    color: t.palette.error.dark,
    marginTop: 24,
    textAlign: 'center'
  },
  footer: {
    marginTop: 24
  }
});

interface State {
  username: string;
  password: string;
  error: boolean;
  showSignUp: boolean;
  loading: boolean;
}

class AcceptInvite extends React.Component<WithStyles & RouteComponentProps<any>, State> {
  state = {
    username: '',
    password: '',
    error: false,
    showSignUp: false,
    loading: false
  };

  handleChangeUsername = (
    event: any
  ) => {
    event.preventDefault();
    this.setState({ username: event.currentTarget.value });
  };

  handleChangePassword = (
    event: any
  ) => {
    event.preventDefault();
    this.setState({ password: event.currentTarget.value });
  };

  handleSubmit = async (e: any, mutateFn: () => void) => {
    e.preventDefault();
    this.setState({ loading: true });
    
    const { username, password } = this.state;
    try {
      if (!this.state.showSignUp) {
        await firebaseLogin(username, password);
      } else {
        await firebaseSignup(username, password);
      }
      // HACK: Waiting until firebase token is updated
      setTimeout(
        () => {
          mutateFn();
          this.setState({ loading: false });
        },
        1000
      );
    } catch (err) {
      console.error(err);
      this.setState({ error: true, loading: false });
    }
  };

  render() {
    const { classes, history, match } = this.props;
    const { loading, username, password, showSignUp, error } = this.state;
    return (
      <AcceptInviteProvider
        params={{ token: match.params.token }}
        onCompleted={farmId => history.push(`/farms/${farmId}`)}
      >
        { (mutateFn, executing) =>
          <main className={classes.root}>
            <Grid container={true} justify="center">
              <Grid item={true} xs={12} sm={10} md={10} lg={4}>
                <form onSubmit={evt => this.handleSubmit(evt, mutateFn)}>
                  <Typography variant="headline" className={classes.title}>
                    {!showSignUp ? 'Ingresar' : 'Registrarse'}
                  </Typography>

                  <TextField
                    type="email"
                    label="Email"
                    fullWidth={true}
                    onChange={this.handleChangeUsername}
                    value={username}
                    className={classes.input}
                    required={true}
                  />
                  <TextField
                    type="password"
                    label="Contraseña"
                    fullWidth={true}
                    onChange={this.handleChangePassword}
                    value={password}
                    required={true}
                  />

                  {error ? (
                    <Typography variant="subheading" className={classes.error}>
                      {!showSignUp ? 'Contraseña o email inválido' : 'El usuario ya existe'}
                    </Typography>
                  ) : null}

                  <div className={classes.footer}>
                    <Button
                      type="submit"
                      variant="raised"
                      color="primary"
                      style={{ float: 'right' }}
                      disabled={executing || loading}
                    >
                      Enviar
                    </Button>
                    { !showSignUp ?
                      <Button variant="raised" onClick={() => this.setState({ showSignUp: true })}>
                        ¿Todavía no te has registrado?
                      </Button>
                    :
                      <Button variant="raised" onClick={() => this.setState({ showSignUp: false })}>
                        Ya tengo usuario
                      </Button>
                    }
                  </div>
                </form>
              </Grid>
            </Grid>
          </main>
        }
      </AcceptInviteProvider>
    );
  }
}

export default withStyles(styles)(withRouter(AcceptInvite));



// WEBPACK FOOTER //
// ./src/containers/AcceptInvite.tsx